export enum LayoutEnum {
    row = 'row',
    column = 'column'
}
